import React, {Component} from 'react';

import { connect } from 'react-redux';
import './Mainpage.css'
import Logo from '../../Components/Logos/WapinaLogo';
import Player from '../../Components/Player/Player';
import Shoutbox from '../../Components/Shoutbox/Shoutbox';
import axios from '../../axiosdata';
import DeleteButton from '../../UI/Buttons/EditButton';
import AdminSettingsDropdown from '../../Components/Controls/AdminSettingsDropdown';
import BlockedUsersPanel from '../../Components/Controls/ShoutboxControl';
import ImageUploader from '../../Components/Sponsors/ImageUploader';
import BackdropBlack from '../../UI/Backdrop/BackdropBlack'
import DataUploader from '../../Components/Calendar/DataUploader';
import Caledar from '../../Components/Calendar/Calendar';
import CaledarMobile from '../../Components/Calendar/CalendarMobile';
import InformationEditor from '../../Components/Information/InformationEditor';
import CallStudio from '../../Components/Call/CallStudioPlayer';
import * as actions from '../../store/actions/index';


class Mainpage extends Component{

    state = {
        showShoutbox: null,
        showSponsorsSettingsDropDown: false,
        showShoutboxSettingsDropDown: false,
        showCalendarSettingsDropDown: false,
        sponsors: null,
        sponsorsElement: <div></div>,
        showDeleteOptions: false,
        showAddOptions: false,
        id: 'show',
        showAddProgram: false,
        informationData: null,
        programsVersion: 0,
        actionError: null
    }

    componentDidMount() {
        this.getdata();
        this.getSponsors();
        this.getInformation();
        window.scrollTo(0, 0);
    }
 
    getdata = () => {

        axios.get('/shoutbox.json')
        .then(res => {
            this.setState({showShoutbox: res.data.show.show})
        })
        .catch(err => console.error('Failed to fetch shoutbox state:', err));
    }

    /* Haetaan firebasesta sponsorit */

    getSponsors = () => {
        const sponsors = [];
        axios.get('/sponsors.json')
        .then(res => {
            for (let key in res.data){
                sponsors.push({
                    ...res.data[key],
                    id: key,
                });
            }
            this.setState({sponsors: sponsors}, () => this.mapSponsors());
        })
        .catch(err => console.error('Failed to fetch sponsors:', err));
    }

    /* Haetaan firebasesta tietoja tässätapauksessa puhelinumero ja jaetaan tieto reducerin kautta muille komponenteille */

    getInformation = () => {
        const data = [];
        axios.get('/information.json')
        .then(res => {
            for (let key in res.data){
                data.push({
                    ...res.data[key],
                    id: key,
                });
            }
            this.setState({informationData: data})
            this.props.setData(data)
        })
        .catch(err => console.error('Failed to fetch information:', err));
    }

    /* Shoutboxin sulku ja avaus toiminto, muuttaa yhtä atribuuttia firebase tietokannssa */

    openShoutbox = () => {
        const data = {
            show: true
        }
        axios.put(`/shoutbox/${this.state.id}.json`, data)
        .then(() => this.setState({showShoutbox: true, actionError: null}))
        .catch(() => this.setState({ actionError: 'Shoutboxin avaus epäonnistui.' }));
        
        this.setState(prev => ({ showShoutboxSettingsDropDown: !prev.showShoutboxSettingsDropDown }));
    }

    closeShoutbox = () => {
        const data = {
            show: false
        }
        axios.put(`/shoutbox/${this.state.id}.json`, data)
        .then(() => this.setState({showShoutbox: false, actionError: null}))
        .catch(() => this.setState({ actionError: 'Shoutboxin sulku epäonnistui.' }));

        this.setState(prev => ({ showShoutboxSettingsDropDown: !prev.showShoutboxSettingsDropDown }));
    }

    /* Toimto sponsoreiden poistoon firebase tietokannasta */

    deleteSponsor = (elementId) => {
        axios.delete(`/sponsors/${elementId}.json`)
        .then(() => this.getSponsors())
        .catch(() => this.setState({ actionError: 'Sponsorin poisto epäonnistui.' }));
    }

    /* Mapping funktio sponsori elementeille, jokaiselle sponsorielementiin liitetään linkki */

    mapSponsors = () => {
        let sponsorsElementUnAuth  = (
            <div className="logos_container">
               {this.state.sponsors.map((sponsor) =>(
                    <div className="logo_element" key={sponsor.id}>
                        <a href={/^https?:\/\//i.test(sponsor.link.link) ? sponsor.link.link : `https://${sponsor.link.link}`} target="_blank" rel="noopener noreferrer">
                            <img src={sponsor.image} alt=""/>
                        </a>
                    </div>

               ))}
           </div>
        );
        let sponsorsElementAuth  = (
            <div className="logos_container">
               {this.state.sponsors.map((sponsor) =>(
                    <div className="logo_element" key={sponsor.id}>
                        <a href={/^https?:\/\//i.test(sponsor.link.link) ? sponsor.link.link : `https://${sponsor.link.link}`} target="_blank" rel="noopener noreferrer">
                            <img src={sponsor.image} alt=""/>
                        </a>
                        <div className="delete_button">
                           <DeleteButton click={() => this.deleteSponsor(sponsor.id)}>X</DeleteButton>
                        </div>
                    </div>

               ))}
           </div>
        );
        this.setState({ sponsorsElementUnAuth, sponsorsElementAuth });
    }

    /* Asetust toimintojen hallintaa */

    changeSettingsState = (stateToChange) => {
        this.setState(prev => ({ [stateToChange]: !prev[stateToChange] }));
    }

    showDeleteOptions = () => {
        this.setState(prev => ({
            showSponsorsSettingsDropDown: !prev.showSponsorsSettingsDropDown,
            showDeleteOptions: !prev.showDeleteOptions
        }));
    }
    showAddOptions = () => {
        this.setState(prev => ({
            showSponsorsSettingsDropDown: !prev.showSponsorsSettingsDropDown,
            showAddOptions: !prev.showAddOptions
        }));
    }
    closeShowAddOptions = () => {
        this.setState({ showSponsorsSettingsDropDown: false, showAddOptions: false });
    }
    showAddProgram = () => {
        this.setState(prev => ({
            showCalendarSettingsDropDown: !prev.showCalendarSettingsDropDown,
            showAddProgram: !prev.showAddProgram
        }));
    }
    closeAddProgram = () => {
        this.setState({ showCalendarSettingsDropDown: false, showAddProgram: false });
    }
    closeShowAddProgram = () => {
        this.setState({ showCalendarSettingsDropDown: false, showAddProgram: false });
    } 

    render(){
        return(
            <div className="Mainpage_Wrapper">
                <div className="title_container">
                    <div className="logo_container">
                        <Logo/>
                        <h1>Radio Wapina</h1>
                        <span>Väriterapiaa korvakäytävillesi</span>
                      
                    </div>
                    <div className="player">
                        <Player/>
                    </div>
                    <div className="triangle2"></div>
                    <div className="triangle"></div>
                </div>
                

            {this.state.actionError ?
                <div style={{background: '#fdd', color: '#c00', padding: '10px', textAlign: 'center', margin: '8px 0'}}>
                    {this.state.actionError}
                    <button onClick={() => this.setState({actionError: null})} style={{marginLeft: '12px', cursor: 'pointer'}}>✕</button>
                </div>
            : null}
               
                 

                {/* ----------------------------- Sponsors ------------------------------------ */}

                {this.props.adminMode ? <div className="section_separator"></div>: null}
                <div className="sponsor">
                    {this.props.adminMode ?
                    <AdminSettingsDropdown showSponsorsSettings={this.state.showSponsorsSettingsDropDown} click={() => this.changeSettingsState("showSponsorsSettingsDropDown")} delete={this.showDeleteOptions} add={this.showAddOptions}/>
                    : null}
                    <h1>Menossa mukana</h1>
                    {!this.props.adminMode ? this.state.sponsorsElementUnAuth : null}
                    {(this.props.adminMode && !this.state.showDeleteOptions) ? this.state.sponsorsElementUnAuth : null}
                    {(this.props.adminMode && this.state.showDeleteOptions) ? this.state.sponsorsElementAuth : null}
                    {(this.props.adminMode && this.state.showAddOptions) ?
                    <div>
                        <BackdropBlack show={this.state.showAddOptions} clicked={this.closeShowAddOptions}/>
                        <ImageUploader onSuccess={() => { this.getSponsors(); this.closeShowAddOptions(); }}/>
                    </div>
                    : null}
                </div>

               {/* ----------------------------- Sponsors ends ------------------------------------ */}

               {/* ----------------------------- Shoutbox ------------------------------------ */}

                {this.props.adminMode ? <div className="section_separator"></div>: null}
                <div className="Content_2">
                    <h1>Shoutbox</h1>
                    <CallStudio />
                    <Shoutbox isAuthenticated={this.props.adminMode} showShoutbox={this.state.showShoutbox} />
                {this.props.adminMode ?
                <AdminSettingsDropdown showShoutboxSettings={this.state.showShoutboxSettingsDropDown} click={() => this.changeSettingsState("showShoutboxSettingsDropDown")} open={this.openShoutbox} close={this.closeShoutbox}/>
                : null}
                {this.props.adminMode ? <BlockedUsersPanel /> : null}
                </div>


                {/* ----------------------------- Shoutbox ends -------------------------------- */}

                {/* ----------------------------- Calendar Desktop-------------------------------- */}


                {this.props.adminMode ? <div className="section_separator"></div>: null}
                <div className="calendar">
                    <h1>Ohjelmakalenteri</h1>
                {this.props.adminMode ?
                <AdminSettingsDropdown showCalendarSettings={this.state.showCalendarSettingsDropDown} click={() => this.changeSettingsState("showCalendarSettingsDropDown")} addProgram={this.showAddProgram}/>
                : null}
                {(this.props.adminMode && this.state.showAddProgram) ?
                    <div>
                        <BackdropBlack show={this.state.showAddProgram} clicked={this.closeShowAddProgram}/>
                        <DataUploader cancel={this.closeAddProgram} onSuccess={() => { this.setState(p => ({programsVersion: p.programsVersion + 1})); this.closeAddProgram(); }}/>
                    </div>
                    : null}
                    <Caledar refreshKey={this.state.programsVersion}/>
                </div>

                {/* ----------------------------- Calendar ends -------------------------------- */}

                {/* ----------------------------- Calendar Mobile-------------------------------- */}


                <div className="calendarMobile">

                    <h1>Ohjelmakalenteri</h1>
                {this.props.adminMode ?
                <AdminSettingsDropdown showCalendarSettings={this.state.showCalendarSettingsDropDown} click={() => this.changeSettingsState("showCalendarSettingsDropDown")} addProgram={this.showAddProgram}/>
                : null}
                {(this.props.adminMode && this.state.showAddProgram) ?
                    <div>
                        <BackdropBlack show={this.state.showAddProgram} clicked={this.closeShowAddProgram}/>
                        <DataUploader cancel={this.closeAddProgram} onSuccess={() => { this.setState(p => ({programsVersion: p.programsVersion + 1})); this.closeAddProgram(); }}/>
                    </div>
                    : null}
                    <CaledarMobile refreshKey={this.state.programsVersion}/>
                </div>

                {/* ----------------------------- Calendar ends -------------------------------- */}

                {/* ----------------------------- Information start -------------------------------- */}

                {this.props.adminMode ? <InformationEditor onSuccess={this.getInformation}/> : null}

                {/* ----------------------------- Information ends -------------------------------- */}
               

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.isAdmin,
        adminMode: state.auth.adminMode,
        currentProgram: state.play.program,
        information: state.information.data
    }
}

const mapDispatchToProps = dispatch => {
    return{
        setData: (data) => dispatch(actions.setData(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Mainpage);